import { render, staticRenderFns } from "./wtr-tags.vue?vue&type=template&id=c161fc1a&scoped=true&"
import script from "./wtr-tags.vue?vue&type=script&lang=js&"
export * from "./wtr-tags.vue?vue&type=script&lang=js&"
import style0 from "./wtr-tags.vue?vue&type=style&index=0&id=c161fc1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c161fc1a",
  null
  
)

export default component.exports